import ColorHash from 'color-hash-ts';

import { Scatter, ScatterChart } from 'recharts';
import useCalendarChart, { CalendarChartProps } from './CalendarChart';

export type SymptomsChartProps = CalendarChartProps & {
  dayValues: string[][];
};

interface ScatterPoint {
  dayIndex: number;
  dayValue: number;
}

const SymptomsChart: React.FC<SymptomsChartProps> = ({
  dayLabels,
  dayValues,
  dayRange,
  periodDots,
  drawHollowPeriodDots,
  topLabels,
  showMonthLabels,
}) => {
  const colorHash = new ColorHash();

  const { graphHeight, domainMaxDay, domainMinDay, chartBuildingBlocks } = useCalendarChart({
    dayLabels,
    dayRange,
    periodDots,
    drawHollowPeriodDots,
    topLabels,
    showMonthLabels,
  });

  const offset = dayLabels[0].diff(domainMinDay, 'days');

  const allSymptoms = new Set<string>();
  dayValues.forEach(daySymptoms => {
    daySymptoms.forEach(symptom => allSymptoms.add(symptom));
  });
  const symptomMap = Object.fromEntries(
    Array.from(allSymptoms)
      .sort()
      .map((symptom, index) => [symptom, (index / allSymptoms.size) * 3.7 + 1.3]),
  );

  const scatterPoints = new Map<string, ScatterPoint[]>(Object.keys(symptomMap).map(s => [s, []]));
  dayValues.forEach((daySymptoms, dayIndex) => {
    daySymptoms.forEach(symptom => {
      (scatterPoints.get(symptom) as ScatterPoint[]).push({
        dayIndex: dayIndex + 0.5 + offset,
        dayValue: symptomMap[symptom],
      });
    });
  });

  return (
    <ScatterChart
      width={(domainMaxDay.diff(domainMinDay, 'days') + 1) * 14}
      height={graphHeight}
      data={dayValues}
      margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
    >
      {chartBuildingBlocks}
      {Array.from(scatterPoints.entries()).map(([symptom, points]) => (
        <Scatter animationDuration={100} key={symptom} name={symptom} data={points} fill={colorHash.hex(symptom)} />
      ))}
    </ScatterChart>
  );
};
export default SymptomsChart;
